
import React from 'react';
import { Input, InputGroup } from 'rsuite';
import moment from 'moment';

import WidgetCondition from './WidgetCondition';
import Config from '../config/Config'
import Cache from '../frame/Cache';

import WidgetSelect from './WidgetSelect';
import WidgetInputView from './WidgetInputView';
import WidgetDatePicker from './WidgetDatePicker';
import WidgetAttributeDimension from './WidgetAttributeDimension';
import LoadingTag from ".././img/frame/loading.gif";
import WidgetAjax from '../widget/WidgetAjax';

import '../css/analysis.css';
import '../css/tag.css';

class WidgetAttribute extends React.Component
{
    constructor( props )
    {
        super(props);

        this.state = {
            basePath:Config.getBasePath(),
            dateOptions : {
                dateType : "date",
                dateTypes : [{title:'日', value:'date'}],
                datePickerType:'range', 
            },
            conditions:{},
            fuzzySearchInputValue:"",
            isFuzzySearchLoading:false,
            timeout:null,
            fuzzySearchData:[],

        }
        
        this.onInputChange = this.onInputChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.dimensionOnChange = this.dimensionOnChange.bind(this);
        this.onDateSelect = this.onDateSelect.bind(this);
        this.onFuzzySearch = this.onFuzzySearch.bind(this)
        this.onLoadFuzzySearch = this.onLoadFuzzySearch.bind(this)
        // this.clickFuzzySearch = this.clickFuzzySearch.bind(this);
    }

    componentWillReceiveProps( nextProps )
    {
        let conditions = nextProps.conditions!==undefined ? nextProps.conditions : {};
        // if(nextProps.ENTNAME)
        this.setState({conditions:conditions});
        
    }

    onFuzzySearch( value )
    {
        let { basePath } = this.state;

        let params = {
            ENTNAME:value
        }

        WidgetAjax.ajax({url:basePath + '/entity/vague_search', params:params, callback:this.onLoadFuzzySearch}); 
    }

    onLoadFuzzySearch( result )
    {
        if (result.status === 0) 
        {
            this.setState({fuzzySearchData:result.results, isFuzzySearchLoading:true});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * input 框监控
     * @param {*} key 
     */
    onInputChange( value, key )
    {
        let { conditions,timeout } = this.state, filters;
        let { attributes } = this.props;

        if(key === "ENTNAME"){
            if( value.target.value.length > 0 )
            {
                clearTimeout(timeout)
                this.setState({
                    isFuzzySearch:true,
                    isFuzzySearchLoading:false,
                }, ()=>{
                    timeout = setTimeout(()=>{
                        this.onFuzzySearch( value.target.value )
                    }, 1000)
                    this.setState({timeout})
                })
                
            }
            else 
            {
                clearTimeout(timeout)
                this.setState({
                    isFuzzySearch:false
                })
            }
        }


        if( value!==undefined && value.target!==undefined && value.target.value!==undefined && value.target.value!=="" )
        {
            
                conditions[key] = value.target.value;
        }
        else
        {
            delete conditions[key];
        }

        if( this.props.notify!==undefined && this.props.notify!==null )
        {
            
            this.props.notify(conditions);
        }
        
    }

    /**
     * 数值输入框回调函数
     * @param {*} value 
     * @param {*} name 
     * @param {*} type 
     */
    onNumberChange( value, name, type )
    {
        let { conditions } = this.state, filters;

        if( conditions[name]===undefined )
        {
            conditions[name] = {};
        }

        if( value!==undefined && value!==null && value!=="" )
        {
            conditions[name][type] = value; 
        }
        else
        {
            if( (conditions[name]["start"]===undefined || conditions[name]["start"]===null || conditions[name]["start"]==="" )
                && (conditions[name]["end"]===undefined || conditions[name]["end"]===null || conditions[name]["end"]==="")  )
            {
                delete conditions[name];
            }
        }
    
        if( this.props.notify!==undefined && this.props.notify!==null )
        {
          
            this.props.notify(conditions);
        }
    }

    /**
     * 单选框变化
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     * @param {*} type 
     */
    onSelectChange( value, item, event, key)
    {
        let { conditions } = this.state, filters;

        if( value!==undefined && value!==null && value!=="")
        {
            conditions[key] = value;
        }
        else
        {
            delete conditions[key];
        }

        if( this.props.notify!==undefined && this.props.notify!==null )
        {
            this.props.notify(conditions);
        }
    }

    /**
     * 日期筛选
     * @param {*} value 
     */
    onDateSelect( value )
    {
        let { conditions } = this.state, filters;

        const key = value.options.name;

        if( value!==undefined )
        {
            conditions[key] = {start:value.start, end:value.end};
        }
        else
        {
            delete conditions[key]; 
        }

        if( this.props.notify!==undefined && this.props.notify!==null )
        {
            this.props.notify(conditions);
        }
    }

    /**
     * 维度筛选条件变化
     * @param {*} content 
     */
    dimensionOnChange( condition, attribute )
    {
        let { conditions } = this.state, filters ;

        let key = attribute.content.code;
        if( condition!==undefined && condition!==null )
        {
            conditions[key] = condition;
        }
        else
        {
            delete conditions[key];
        }

        if( this.props.notify!==undefined && this.props.notify!==null )
        {
            this.props.notify(conditions);
        }
    }

    clickFuzzySearch( value,key )
    {
        this.setState({
            fuzzySearchInputValue:value,
            isFuzzySearch:false,
        })
        let {conditions} = this.state

        conditions["ENTNAME"] = value.entname;
        
        this.props.notify(conditions);
    }

    // inputOnBlur ( value, key )
    // {
        // let {conditions} = this.state
        // conditions[key] = value;

        // this.props.notify(conditions);

    // }

    render()
    {
        let { dateOptions, fuzzySearchData, isFuzzySearch, fuzzySearchInputValue, isFuzzySearchLoading } = this.state;

        let { attributes, conditions } = this.props;
        if( attributes!==undefined && attributes!==null && attributes.length>0 )
        {
            if( conditions===undefined || conditions===null )
            {
                conditions = {};
            }

            return (
                <div className="attribute-search">
                    {
                        attributes.map((item, index) => {
                            if( item.type==="STRING" )
                            { 
                                return (
                                    <div className="attribute" key={index}>
                                        <span className="span1" title={item.title}>{item.title}</span>
                                        <span className="span2">
                                            <WidgetInputView flag={this.props.flag} value={conditions[item.name]!==undefined? conditions[item.name]:undefined} 
                                                onChange={(value) =>{this.onInputChange(value, item.name)}}
                                                // onBlur={() => this.inputOnBlur()}
                                                />

                                                <div className='tagSearch' style={isFuzzySearch && this.props.block? {display:"block",zIndex:"999"}:{display:"none"}}>
                                                {
                                                    isFuzzySearchLoading ?
                                                    fuzzySearchData.length === 0 || fuzzySearchData[0] == null?
                                                    <div> { `未找到包含 “${fuzzySearchInputValue}” 关键词的公司` } </div>:
                                                    fuzzySearchData.map((val,index)=>{
                                                        if( val!==null && val!==undefined && val!=="" )
                                                        {
                                                            return <div key={index} className='fontClick' onClick={()=>{this.clickFuzzySearch(val,item.name)}}>{val.entname}</div>
                                                        }
                                                    })
                                                    :
                                                    <img src={LoadingTag} className=' isFuzzySearchLoadingTag' />
                                                }
                                            </div>

                                        </span>
                                    </div>
                                )
                            }
                            else if( item.type==="DATE" )
                            {
                                let dateStart = undefined, dateEnd = undefined;
                
                                dateOptions["name"] = item.name;
                                dateOptions["isLeftTitle"] = false;
                
                                if( conditions[item.name]!==undefined )
                                {
                                    dateStart = conditions[item.name].start;
                                    dateEnd = conditions[item.name].end;
                                }
                
                                return (
                                    <div className="attribute" key={index}>
                                        <span className="span1" title={item.title}>{item.title}</span>
                                        <span className="span2">
                                            <WidgetDatePicker onSelect={(value)=>{this.onDateSelect(value)}} 
                                                defaultValue={{dateStart:dateStart, dateEnd:dateEnd, dateType:"date"}}
                                                options={dateOptions} flag={this.props.flag}/>
                                        </span>
                                    </div>
                                )
                            }
                            else if( item.type==="NUMBER" || item.type==="INTEGER" )
                            {
                                let valueStart = "" , valueEnd = "";
                                if( conditions[item.name]!==undefined )
                                {
                                    valueStart = conditions[item.name].start!==undefined ? conditions[item.name].start : "";
                                    valueEnd = conditions[item.name].end!==undefined ? conditions[item.name].end : "";
                                }
                            
                
                                return (
                                    <div className="attribute" key={index}>
                                        <span className="span1" title={item.title}>{item.title}</span>
                                        <span className="span2">
                                            <InputGroup style={{width:"100%", maxWidth:300}} >
                                                <Input onChange={(value) =>{this.onNumberChange(value, item.name, "start")}} value={valueStart}/>
                                                <InputGroup.Addon>至</InputGroup.Addon>
                                                <Input onChange={(value) =>{this.onNumberChange(value, item.name, "end")}} value={valueEnd }/>
                                            </InputGroup>
                                        </span>
                                    </div>
                                )
                            }
                            else if( item.type==="NOMINAL" )
                            {
                                let data = [];
                
                                for( let contentItem of item.content )
                                {
                                    contentItem["label"] = contentItem.name;
                                    data.push(contentItem);
                                }
                
                                let selectOptions = {
                                    title : "",
                                    cleanable : true
                                }
                
                                return (
                                    <div className="attribute" key={index}>
                                        <span className="span1" title={item.title}>{item.title}</span>
                                        <span className="span2">
                                            <WidgetSelect data={data} options={selectOptions} onSelect={(value, itemData, e) => { this.onSelectChange(value, itemData, e, item.name)}} defaultValue={conditions[item.name]}/>
                                        </span>
                                    </div>
                                );
                                
                            }
                            else if( item.type==="DIMENSION" )
                            {
                                let values = conditions[item.content.code];
            
                                return (
                                    <div className="attribute" key={index}>
                                        <span className="span1" title={item.title}>{item.title}</span>
                                        <span className="span2">
                                            <WidgetAttributeDimension attribute={item} values={values} notify={this.dimensionOnChange} />
                                        </span>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            )
        }
        else
        {
            return <i></i>
        }
       
        
    }
}
export default WidgetAttribute

